<template>

  <b-row>
    <b-col>
      <b-card
        style="margin:0;border:1px solid #2980b9;padding:0 10px"
        no-body
        :class="{ 'open': visibleBody }"
      >
        <b-card-header
          :class="{ 'collapsed': !visibleBody }"
          :aria-expanded="visibleBody ? 'true' : 'false'"
          role="tab"
          data-toggle="collapse"
          @click="onVisibleBody(!visibleBody)"
          style="color: black; font:45px; padding: 0 1px; cursor: pointer;"
        >
            
          <span
            v-if="especialidad === 7 || especialidad === '7'"
            class="lead collapse-title"
          >
            <strong>DEMANDA ACTUAL </strong>
          </span>

          <span v-else class="lead collapse-title">
            <strong>PROBLEMA ACTUAL</strong>
          </span>

          <i :class="visibleBody ? 'fas fa-chevron-up' : 'fas fa-chevron-down'" />
        </b-card-header>

        <b-collapse
          v-model="visibleBody"
          role="tabpanel"
        >
          <b-card-body 
            style="padding: 1.5rem"
          >
            <b-form-group style="margin:0" label="Escribir el problema actual: ">
              <b-form-textarea
                v-model="descripcionProblema"
                placeholder="Describa el problema actual"
                rows="12"
              />
            </b-form-group>

            <b-form-group  class = "mt-1" >
              <b-button 
                @click = "copyAS400()" 
                variant = "info"
              >
                AS400  <i class="fas fa-copy"/>
              </b-button>
            </b-form-group>

          </b-card-body>
        </b-collapse>
      </b-card>
    </b-col>
  </b-row>
  
</template>

<script>
import { mapState } from 'vuex';
import { calculateAgeWithDateString, calculteAgeYearsMonthsDays, copyText } from '@/shared/helpers';
import { tipoUrologica }    from './tipoUrologica';
import { tipoOtorrino }     from './tipoOtorrino';
import { tipoNeumologica }  from './tipoNeumologica';
import { tipoAlergologica } from './tipoAlergologica';
import { tipoStandard }     from './tipoStandard';
import { tipoGastro }       from './tipoGastro';
import { tipoGineco }       from './tipoGineco';

export default {
  name: "ProblemaActual",

  data(){
    return {
      visibleBody : false,
      especialidad: null,

      descripcionProblema: ''
    }
  },

  created() {
    this.updateDescripcionProblema();
  },

  methods: {
    onVisibleBody(value) {
      this.visibleBody = value;
    },

    copyAS400() {
      copyText(this.descripcionProblema)
     
    },

    // async updateDescripcionProblema() {
    //   if(this.stProblemaActual){
    //     this.descripcionProblema = this.stProblemaActual
    //   }else {
    //     this.descripcionProblema = this.generarDescripcionProblema();
    //   }
    // },


    updateDescripcionProblema() {
      this.descripcionProblema = this.generarDescripcionProblema();
    },

    generarDescripcionProblema() {
      const textoProblema = `Paciente ${this.pacienteSexo} ${this.pacienteEdad} ${this.pacienteProfesion} asiste a cita medica ${this.textoOcurrencia}${this.textoMotivoConsulta}${this.textoSemiologia}`;
      return textoProblema.toUpperCase();
    }
  },

  watch: {
    paciente: {
      deep: true,
      handler: 'updateDescripcionProblema'
    },

    stSemiologia: {
      deep: true,
      handler: 'updateDescripcionProblema'
    },

    motivoConsulta: {
      deep: true,
      handler: 'updateDescripcionProblema'
    },

    descripcionProblema:{
      deep: true,
      handler( newValue ){
        this.$store.commit("setProblemaActual", newValue );
      }
    }
    
  },

  computed: {

    ...mapState({
      dataAtencionMedica: state => state.atencionCita.dataCita,
      doctor            : state => state.atencionCita.dataCita.doctor,
      paciente          : state => state.atencionCita.dataCita?.paciente || null,
      motivoConsulta    : state => state.atencionCita.anamnesis?.motivoConsulta,
      ocurrencia        : state => state.atencionCita.anamnesis?.ocurrencia,
      stSemiologia      : state => state.atencionCita.anamnesis?.semiologia,
      stProblemaActual  : state => state.atencionCita.anamnesis?.problemaActual
    }),

    pacienteSexo() {
      return this.paciente?.persona.sexo === 0 ? 'masculino' : 'femenino'
    },

    pacienteEdad(){

      if(!this.paciente?.persona.fechaNacimiento) return '';
      // const edad = calculateAgeWithDateString(this.paciente?.persona.fechaNacimiento);
      const edad = calculteAgeYearsMonthsDays(this.paciente?.persona.fechaNacimiento);
      if(edad.years > 15 ) return `de ${edad.years} años de edad`;
      
      const textoEdad = `con ${edad.years} años ${edad.months} meses ${edad.days} días de edad`;
      return textoEdad
    },

    pacienteProfesion(){
      const ocupacion = this.paciente?.persona.ocupacion?.descripcion || "";
      const textoProfesion = ocupacion ? `que se desempeña como ${ocupacion}` : '';
      return textoProfesion;
    },

    textoOcurrencia() {
      if (!this.ocurrencia) return '';
    
      const ocurrencia = this.ocurrencia === '1' 
        ? 'primera vez' 
        : this.ocurrencia === '2' 
          ? 'subsecuente' 
          : 'revision de estudios';

      const text = `por ${ocurrencia}`;
      return text;
    },

    textoMotivoConsulta() {
      if (!this.motivoConsulta) return '';
      let motivoConsulta = ''
      if (this.motivoConsulta && this.motivoConsulta.textoMotivo){
        motivoConsulta = this.motivoConsulta.textoMotivo
      } else {
        motivoConsulta = this.motivoConsulta
      }
      
      const text = ` con motivo de ${motivoConsulta}`;
      return text;
    },

    textoSemiologia(){
      if(!this.stSemiologia) return '';

      let texto = ''
      const tipoSemiologia = this.stSemiologia?.tipo
      const dataSemiologia = this.stSemiologia?.data

      if( tipoSemiologia === 'oncologica' || tipoSemiologia === 'fisiatrica' )
        texto = tipoStandard(dataSemiologia)

      if( tipoSemiologia === 'alergologica' ) texto = tipoAlergologica(dataSemiologia);
      if( tipoSemiologia === 'neumologica')   texto = tipoNeumologica(dataSemiologia);
      if( tipoSemiologia === 'otorrino')      texto = tipoOtorrino(dataSemiologia);
      if( tipoSemiologia === 'urologica')     texto = tipoUrologica(dataSemiologia);
      if( tipoSemiologia === 'gastro')        texto = tipoGastro(dataSemiologia);
      if( tipoSemiologia === 'gineco')        texto = tipoGineco(dataSemiologia);

      return texto.toUpperCase();
    },

  },

}
</script>
